import { isPromoValid } from '@shared/utils/promotions';
import type { PromotionConfig } from '@shared/utils/promotions';
import type { StationeryDiscountInfo } from '../types';
import { useCallback } from 'react';
import type { StationeryTemplateCategoryEnum } from '@graphql/generated-base';

export const usePromoConfigToStationeryDiscount = () => {
  const promoConfigToStationeryDiscount = useCallback(
    (promotion: PromotionConfig | undefined, category: StationeryTemplateCategoryEnum, vendor: string): StationeryDiscountInfo | undefined => {
      if (!promotion) {
        return undefined;
      }

      const isValid = isPromoValid(promotion, { occasion: 'wedding', category, vendor });

      if (!isValid) {
        return undefined;
      }

      return {
        type: 'percent',
        promoCode: promotion.code,
        percentage: promotion.discountPercentage,
      };
    },
    [],
  );

  return {
    promoConfigToStationeryDiscount,
  };
};
